import { Suspense, lazy } from 'react';

import { Spinner } from '@/common/components';
import { AppControllerType, AppRoutes } from '@/common/interfaces';

import { DynamicBaseBreadcrumb, DynamicSitesBreadcrumb } from '@/modules/AppBreadcrumb';

const ReferralsPage = lazy(async () => await import('../../../pages/Sites/SitesReferrals/Referrals.page'));
const ReferralsListPage = lazy(async () => await import('../../../pages/Sites/SitesReferrals/ReferralsList.page'));
const ReferralsCreatePage = lazy(async () => await import('../../../pages/Sites/SitesReferrals/ReferralsCreate.page'));
const ReferralsEditPage = lazy(async () => await import('../../../pages/Sites/SitesReferrals/ReferralsEdit.page'));

export const ReferralsController: AppControllerType = {
  common: [
    {
      path: AppRoutes.Referrals + '/*',
      element: (
        <Suspense fallback={ <Spinner/> }>
          <ReferralsListPage/>
        </Suspense>
      ),
      breadcrumb: DynamicSitesBreadcrumb.DynamicReferralsBreadcrumb
    }
  ],
  drawer: [
    {
      path: AppRoutes.ReferralsCreate,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <ReferralsCreatePage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseCreateBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    },
    {
      path: AppRoutes.ReferralsEdit,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <ReferralsEditPage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseEditBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    },
    {
      path: AppRoutes.ReferralsById,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <ReferralsPage/>
        </Suspense>
      ),
      breadcrumb: DynamicSitesBreadcrumb.DynamicReferralsByIdBreadcrumb,
      props: {
        commonDrawerWidth: 520
      }
    },
  ]
};
